<template>
  <ModalBase
    :is-active="props.isActive"
    @update:is-active="value => $emit('update:isActive', false)"
  >
    <div class="title">
      Добавление тега
    </div>
    <div class="list">
      <div class="list__item">
        <InputPrimary
          v-model="feedParams.name"
          placeholder="Название"
          size="large"
        />
      </div>
      <div class="list__item">
        <InputPrimary
          v-model="feedParams.category"
          placeholder="Категория"
          size="large"
        />
      </div>
    </div>
    <ButtonAccentPrimary
      size="large"
      @click="createTag"
    >
      Создать
    </ButtonAccentPrimary>
  </ModalBase>
</template>

<script setup>
import { defineEmits, defineProps, reactive } from "vue";
import ModalBase from "@/components/UI/ModalBase.vue";
import {useTags} from "@/stores/tags";

const emit = defineEmits(["update:isActive", "added"]);

const tagStore = useTags();

const props = defineProps({
    isActive: {
        type: Boolean,
        required: true
    },
});

const feedParams = reactive({
    formSubmited: false,
    name: "",
    category: "",
});

const createTag = async () => {
    try {
        feedParams.feedParamsformSubmited = true;
        
        const payload = {
                name: feedParams.name,
                category: feedParams.category,
            };
        
        const response = await tagStore.createTag(payload);
        emit("added");
    } catch (err) {
        console.error(err);
    } finally {
        emit("update:isActive", false);
        feedParams.formSubmited = false;
    }
};
</script>

<style lang="scss" scoped>
.title {
    margin-bottom: 30px;
    font-family: var(--font-family);
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: #212327;
}

.list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 30px;
    &__item {
        flex: 0 0 calc(50% - 10px);
        & input {
            border: 1px solid var(--outline-input);
            border-radius: 8px;
            padding: 8px 12px;
            width: 100%;
            font-size: 14px;
        }
        & select {
            width: 100%;
            padding: 13px;
            background: transparent;
            border: 1px solid var(--outline-input);
            border-radius: 8px;
            font-size: 14px;
        }
    }

    &__item-subtitle {
        font-family: var(--font-family);
        font-weight: 400;
        font-size: 14px;
        line-height: 140%;
        color: var(--outline-grey3);
        margin-bottom: 10px;
    }
}

.tags {
    display: flex;
    gap: 5px;
    border: 1px solid var(--outline-input);
    border-radius: 8px;
    padding: 6px 12px 6px 4px;

}

.tag {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: 14px;
    line-height: 143%;
    color: var(--outline-grey3);
}
</style>
